import { Image } from 'components'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { useHistory } from 'react-router-dom'

import styled from 'styled-components'

const BackButtonWrap = styled.div`
  width: 90px;
  height: 40px;
  left: 165px;
  top: 75px;
  background: #ffffff;
  border-radius: 20px;
  display: flex;
  flex-flow: row nowrap;
  justify-content: center;
  align-items: center;
  cursor: pointer;
`

const Text = styled.div`
  font-family: 'SF Pro Rounded';
  font-style: normal;
  font-weight: 700;
  font-size: 16px;
  color: #01142a;
  margin-left: 8px;
`

const BackButton: React.FunctionComponent<{ path?: string }> = ({ path }) => {
  const { t } = useTranslation()
  const history = useHistory()
  return (
    <BackButtonWrap onClick={() => (path ? history.push(path) : history.goBack())}>
      <Image
        src={require('../../../assets/images/lottery/back-icon.png').default}
        width="15.1px"
        height="14.6px"
        alt="back-icon"
      />
      <Text>{t('LOTTERY_176')}</Text>
    </BackButtonWrap>
  )
}

export default BackButton
